import * as React from 'react'

export interface IProps {
  variantId: number
  children?: React.ReactNode
}

class Variant extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
  }

  public render() {
    return this.props.children
  }
}

export default Variant



// WEBPACK FOOTER //
// ./client/components/experiment/variant.tsx